module.exports = __webpack_public_path__ + "fonts/msg.svg?v=8f3d48b034580899ef04867dc5948149";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/msg.svg
// module id = 696
// module chunks = 0